// RU-PREVIEWGATE2 (PG2-12): one service worker at scope "/". Web push subscribes through the existing
// registration (the build's service-worker.js, which carries the push handlers). Registering another script
// at the same scope would replace that worker (and the next page load would replace it back).
export const READY_TIMEOUT_MS = 10000;
export const NOT_ACTIVE_MESSAGE = "Service worker is not active yet — try again in a moment";

// PG2-15: pushManager.subscribe needs an active worker — wait for `ready`, bounded, and fail with a clear error.
function waitForActive(sw, fallbackReg, timeoutMs) {
  let timer;
  const timeout = new Promise((_, reject) => {
    timer = setTimeout(() => reject(new Error(NOT_ACTIVE_MESSAGE)), timeoutMs);
  });
  return Promise.race([Promise.resolve(sw.ready), timeout])
    .then((ready) => ready || fallbackReg)
    .finally(() => clearTimeout(timer));
}

export async function getPushRegistration(sw, { production = process.env.NODE_ENV === "production",
                                                publicUrl = process.env.PUBLIC_URL || "",
                                                timeoutMs = READY_TIMEOUT_MS } = {}) {
  const existing = await sw.getRegistration();
  if (existing) {
    if (existing.active) return existing;
    return waitForActive(sw, existing, timeoutMs);   // still installing / waiting
  }
  // No worker yet: in production register the build's worker (same URL as serviceWorkerRegistration);
  // in development the build worker is never registered, so the push-only public/sw.js is used.
  const url = production ? `${publicUrl}/service-worker.js` : "/sw.js";
  const reg = await sw.register(url, { scope: "/" });
  return waitForActive(sw, reg, timeoutMs);
}
